<div class="loading-full-page" *ngIf="isLoading | async">
  <mat-progress-bar class="loading-full-page__progess-bar" mode="indeterminate"></mat-progress-bar>
</div>
<form
  class="field-dialog__content__scroll p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fxLayout="column"
  name="form"
  [formGroup]="maintenancesForm"
  fusePerfectScrollbar
>
  <app-info-banner
    *ngIf="maintenance.previousMaintenance"
    [maintenance]="maintenance.previousMaintenance"
  ></app-info-banner>
  <div *ngIf="maintenance.labels && maintenance.labels.length && hasLabelViewPermission" class="mb-16" class="row">
    <span *ngFor="let label of maintenance.labels" class="label" [ngClass]="label.color">
      {{ label.name }}
    </span>
  </div>

  <div class="row">
    <mat-form-field appearance="legacy" fxFlex="20" class="m-0">
      <mat-label>{{ 'MAINTENANCES.NUMBER' | translate }}</mat-label>
      <input matInput formControlName="number" required />
    </mat-form-field>

    <maintenance-type
      appearance="legacy"
      [maintenanceTypes]="maintenanceTypes"
      formControlName="typeId"
      fxFlex="40"
      [disabled]="!validStatusToEditMaintenance.includes(maintenance.status)"
    >
    </maintenance-type>

    <segments
      #segmentInput
      fxFlex="40"
      formControlName="segment"
      appearance="legacy"
      [disabled]="!validStatusToEditMaintenance.includes(maintenance.status)"
    >
    </segments>
  </div>

  <div class="row">
    <mat-form-field
      appearance="legacy"
      class="pr-8"
      [matTooltip]="this.maintenance.location?.address?.formattedAddress"
    >
      <mat-label>{{ 'MAINTENANCES.LOCATION' | translate }}</mat-label>
      <input matInput [value]="this.maintenance.location?.name" disabled />
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="20" class="pr-8 m-0" *showIfHasFeatureFlag="'weight'">
      <mat-label>{{ 'MAINTENANCES.WEIGHT' | translate }}</mat-label>
      <input matInput formControlName="weight" required />
      <mat-error *ngIf="maintenancesForm.get('weight').errors">
        {{ 'MAINTENANCES.ERRORS.WEIGHT' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <address
      fxFlex="100"
      [editableValue]="false"
      [addressForm]="maintenancesForm.get('address')"
      [isViewMode]="isViewMode"
    ></address>
  </div>

  <div class="row">
    <requesters
      appearance="legacy"
      formControlName="requesterId"
      [required]="true"
      [disabled]="true"
      fxFlex="40"
      class="pr-8"
    >
    </requesters>

    <problems
      #problemInput
      fxFlex
      formControlName="problemId"
      appearance="legacy"
      [problems]="problems"
      [floatLabel]="true"
      [required]="false"
      [equipmentTypeId]="
        maintenance.equipments && maintenance.equipments[0] && maintenance.equipments[0].id
          ? maintenance.equipments[0].id
          : null
      "
      [segmentId]="segmentInput.selectValue.value || null"
      [disabled]="!segmentInput.selectValue.value"
    >
    </problems>
  </div>

  <schedule-suggestions
    *ngIf="shouldShowScheduleSuggestion"
    class="field-dialog__content__scroll__new-schedule-suggestions"
    [maintenanceId]="maintenance.id"
    [form]="maintenancesForm"
    (isLoading)="isLoading.emit($event)"
  ></schedule-suggestions>

  <div class="field-dialog__content__scroll__message">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'MAINTENANCES.HEADER.MESSAGE' | translate }}</mat-label>
      <textarea
        matInput
        matTextareaAutosize
        [placeholder]="'MAINTENANCES.HEADER.MESSAGE' | translate"
        matAutosizeMinRows="2"
        matAutosizeMaxRows="50"
        formControlName="message"
        required
      ></textarea>

      <mat-hint align="end"> {{ maintenancesForm.get('message').value?.length || 0 }}/2000 </mat-hint>

      <mat-error *ngIf="maintenancesForm.get('message').errors?.required">
        {{ 'MAINTENANCES.ERRORS.MESSAGE_REQUIRED' | translate }}
      </mat-error>

      <mat-error *ngIf="maintenancesForm.get('message').errors?.maxlength">
        {{ 'MAINTENANCES.ERRORS.MESSAGE_MAX_LENGTH' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <status formControlName="status" appearance="legacy" fxFlex="25" class="pr-4" [disabled]="true"> </status>
    <assignees formControlName="assignee" appearance="legacy" fxFlex class="pl-4" [disabled]="isViewMode"> </assignees>
  </div>

  <div style="align-items: flex-start" class="row">
    <companies
      fxFlex="50"
      appearance="legacy"
      formControlName="company"
      floatLabel="true"
      [preloadResults]="true"
      [compareWithCoords]="addressCoords"
      [disabled]="maintenance.company?.fieldAccountId || isViewMode"
    >
    </companies>

    <fc-deadline-contract-outlined-select
      fxFlex="50"
      [label]="'MAINTENANCES.TABS.GENERAL.INPUTS.DEADLINE_CONTRACT.LABEL' | translate"
      [control]="maintenancesForm.get('deadlineContract')"
      [required]="false"
    ></fc-deadline-contract-outlined-select>
  </div>

  <div class="row">
    <mat-form-field appearance="legacy" fxFlex="50" class="pr-4">
      <mat-label>{{ 'MAINTENANCES.OPENED_DATE' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="openedPicker"
        formControlName="openedDate"
        placeholder="{{ 'MAINTENANCES.OPENED_DATE' | translate }}"
        disabled
      />
      <mat-datepicker-toggle matSuffix [for]="openedPicker"></mat-datepicker-toggle>
      <mat-datepicker #openedPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="50" class="pl-4">
      <mat-label>{{ 'MAINTENANCES.OPENED_TIME' | translate }}</mat-label>
      <input matInput formControlName="openedTime" placeholder="__:__" mask="Hh:m0" />
    </mat-form-field>
  </div>

  <div *ngIf="maintenancesForm.get('scheduledDate') && maintenancesForm.get('scheduledTime')" class="row">
    <mat-form-field appearance="legacy" fxFlex="50" class="pr-4">
      <mat-label>{{ 'MAINTENANCES.SCHEDULED_DATE' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="scheduledPicker"
        formControlName="scheduledDate"
        placeholder="{{ 'MAINTENANCES.SCHEDULED_DATE' | translate }}"
        [min]="maintenancesForm.get('openedDate').value"
      />
      <mat-datepicker-toggle matSuffix [for]="scheduledPicker"></mat-datepicker-toggle>
      <mat-datepicker #scheduledPicker></mat-datepicker>
      <mat-error *ngIf="maintenancesForm.get('scheduledDate').errors?.matDatepickerMin">
        {{ 'MAINTENANCES.ERRORS.DATE_INVALID' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="50" class="pl-4">
      <mat-label>{{ 'MAINTENANCES.SCHEDULED_TIME' | translate }}</mat-label>
      <input matInput formControlName="scheduledTime" placeholder="__:__" mask="Hh:m0" />
      <mat-error *ngIf="maintenancesForm.get('scheduledTime').errors?.invalid">
        {{ 'MAINTENANCES.ERRORS.TIME_INVALID' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="maintenancesForm.get('startDate') && maintenancesForm.get('startTime')" class="row">
    <mat-form-field appearance="legacy" fxFlex="50" class="pr-4">
      <mat-label>{{ 'MAINTENANCES.START_DATE' | translate }}</mat-label>
      <input
        matInput
        [matDatepicker]="startPicker"
        formControlName="startDate"
        placeholder="{{ 'MAINTENANCES.START_DATE' | translate }}"
        [min]="maintenancesForm.get('openedDate').value"
      />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
      <mat-error *ngIf="maintenancesForm.get('startDate').errors?.matDatepickerMin">
        {{ 'MAINTENANCES.ERRORS.DATE_INVALID' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="50" class="pl-4">
      <mat-label>
        {{ 'MAINTENANCES.START_TIME' | translate }}
      </mat-label>
      <input matInput formControlName="startTime" placeholder="__:__" mask="Hh:m0" />
      <mat-error *ngIf="maintenancesForm.get('startTime').errors?.invalid">
        {{ 'MAINTENANCES.ERRORS.TIME_INVALID' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="maintenancesForm.get('closedDate') && maintenancesForm.get('closedTime')" class="row">
    <mat-form-field appearance="legacy" fxFlex="50" *ngIf="isClosedMaintenance" class="pr-4">
      <mat-label>{{
        (maintenancesForm.get('status').value === 'done' ? 'MAINTENANCES.DONE_DATE' : 'MAINTENANCES.CANCELED_DATE')
          | translate
      }}</mat-label>
      <input
        matInput
        [matDatepicker]="closedPicker"
        formControlName="closedDate"
        placeholder="{{
          (maintenancesForm.get('status').value === 'done' ? 'MAINTENANCES.DONE_DATE' : 'MAINTENANCES.CANCELED_DATE')
            | translate
        }}"
        [min]="maintenancesForm.get('openedDate').value"
      />
      <mat-datepicker-toggle matSuffix [for]="closedPicker"></mat-datepicker-toggle>
      <mat-datepicker #closedPicker></mat-datepicker>
      <mat-error *ngIf="maintenancesForm.get('closedDate').errors?.matDatepickerMin">
        {{ 'MAINTENANCES.ERRORS.DATE_INVALID' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="legacy" fxFlex="50" *ngIf="isClosedMaintenance" class="pl-4">
      <mat-label>
        {{
          (maintenancesForm.get('status').value === 'done' ? 'MAINTENANCES.DONE_TIME' : 'MAINTENANCES.CANCELED_TIME')
            | translate
        }}
      </mat-label>
      <input matInput formControlName="closedTime" placeholder="__:__" mask="Hh:m0" />
      <mat-error *ngIf="maintenancesForm.get('closedTime').errors?.invalid">
        {{ 'MAINTENANCES.ERRORS.TIME_INVALID' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="isClosedMaintenance" class="row">
    <mat-form-field appearance="legacy" fxFlex="100">
      <mat-label>{{ 'MAINTENANCES.REASON' | translate }}</mat-label>
      <textarea
        matInput
        matTextareaAutosize
        required
        placeholder="{{ 'MAINTENANCES.REASON' | translate }}"
        matAutosizeMinRows="2"
        matAutosizeMaxRows="5"
        formControlName="statusDescription"
      ></textarea>
      <mat-error>{{ 'MAINTENANCES.ERRORS.REASON_REQUIRED' | translate }}</mat-error>
    </mat-form-field>
  </div>
</form>
